__turbopack_context__.v({
  "error-checkmark": "RightPicture-module-scss-module__Zo6Mzq__error-checkmark",
  "right-picture": "RightPicture-module-scss-module__Zo6Mzq__right-picture",
  "right-picture-edit": "RightPicture-module-scss-module__Zo6Mzq__right-picture-edit",
  "right-picture-img": "RightPicture-module-scss-module__Zo6Mzq__right-picture-img",
  "right-picture-overlay": "RightPicture-module-scss-module__Zo6Mzq__right-picture-overlay",
});
